import { IEntity } from '../types';
import { EntityService } from './EntityService';

export class RiskAppSystemService extends EntityService<IEntity> {
    constructor() {
        super(`/RiskAppSystems`);
    }
}
